import React from 'react';
import { IconBase } from '../Base';
export const IconChevronRightLarge = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M7.25 4 L 12.75 10 L 7.25 16", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=RightLarge.js.map